import { useCallback, useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

import { useWindowScroll } from '../../hooks';

import { ScrollRestorationProps } from './ScrollRestoration.types';
import { prunePositions } from './ScrollRestoration.helpers';
import {
    HANDLE_SCROLL_DELAY,
    NAVIGATION_BACK,
    NAVIGATION_REPLACE,
    SCROLL_POSITIONS_KEY,
} from './ScrollRestoration.constants';

export const ScrollRestoration = (props: ScrollRestorationProps) => {
    const { children } = props;

    const location = useLocation();
    const navigationType = useNavigationType();

    const handleScroll = useCallback(() => {
        let positions = JSON.parse(sessionStorage.getItem(SCROLL_POSITIONS_KEY) || '{}');
        positions[location.key] = window.scrollY;
        // Ограничиваем количество хранимых позиций
        positions = prunePositions(positions);
        sessionStorage.setItem(SCROLL_POSITIONS_KEY, JSON.stringify(positions));
    }, [location.key]);

    useEffect(() => {
        // REPLACE-навигация используется для обновления URL без смены страницы
        // (например, выбор категории фильтра) — скролл не сбрасываем
        if (navigationType === NAVIGATION_REPLACE) {
            return;
        }

        if (navigationType !== NAVIGATION_BACK) {
            // Навигация вперёд – сбрасываем скролл
            window.scrollTo(0, 0);

            return;
        }

        // Навигация назад – восстанавливаем позицию
        const scrollPositions = JSON.parse(sessionStorage.getItem(SCROLL_POSITIONS_KEY) || '{}');
        const savedPosition = scrollPositions[location.key];

        if (savedPosition !== undefined) {
            requestAnimationFrame(() => {
                window.scrollTo(0, savedPosition);
            });
        }
    }, [location, navigationType]);

    useWindowScroll(handleScroll, HANDLE_SCROLL_DELAY, { passive: true });

    return children;
};
